module.exports = __webpack_public_path__ + "img/img2.7b2a780b.png";